const UIStrategy = require('./ui_strategy');
const UIStrategyDrawer = require('./ui_strategy_drawer');
const UIStrategyCustomList = require('./ui_strategy_custom_list');

const isMobile = Odigeo.SessionScope.flow === 'mobile';

UIStrategy.factory = ($selectorWrapper, ancillaryContainer, templates, keys, primeInfo) => {
    let UIStrategyClass;

    UIStrategyClass = isMobile
        ? UIStrategyDrawer
        : UIStrategyCustomList;

    return new UIStrategyClass($selectorWrapper, ancillaryContainer, templates, keys, primeInfo);
};

module.exports = UIStrategy;
